import { render } from "./N2nProductDetailModal.vue?vue&type=template&id=267d1206&scoped=true"
import script from "./N2nProductDetailModal.vue?vue&type=script&lang=js"
export * from "./N2nProductDetailModal.vue?vue&type=script&lang=js"

import "./N2nProductDetailModal.vue?vue&type=style&index=0&id=267d1206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267d1206"]])

export default __exports__